export class CreateQuotationDto {
  taxId: number;
  amountME: number;
  amountMN: number;
  vet: number;
  rate: number;
  ptax: number;
  commercial: number;
  token: string;

  /**
   *
   */
  constructor(
    taxId: number,
    amountME: number,
    amountMN: number,
    vet: number,
    rate: number,
    commercial: number,
    ptax: number,
    token: string) {
    this.taxId = taxId;
    this.amountME = amountME;
    this.amountMN = amountMN;
    this.vet = vet;
    this.commercial = commercial;
    this.rate = rate;
    this.ptax = ptax;
    this.token = token;
  }
}
